var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"base-checkbox",class:[
    `base-checkbox-${_vm.variant}`,
    {
      checked: _vm.value,
      disabled: _vm.disabled,
      'icon-right': _vm.iconPosition === 'right'
    }
  ]},[_c('input',{staticClass:"base-checkbox-input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.handleChange}}),(_vm.iconPosition !== 'right')?_c('span',{staticClass:"base-checkbox-marker",attrs:{"aria-hidden":"true"}},[(_vm.value)?_c('img',{staticClass:"base-checkbox-icon",attrs:{"src":_vm.checkedIcon,"alt":""}}):_vm._e()]):_vm._e(),_c('span',{staticClass:"base-checkbox-content"},[_vm._t("default")],2),(_vm.iconPosition === 'right')?_c('span',{staticClass:"base-checkbox-marker",attrs:{"aria-hidden":"true"}},[(_vm.value)?_c('img',{staticClass:"base-checkbox-icon",attrs:{"src":_vm.checkedIcon,"alt":""}}):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }